import actions from './bookmark.actions'

export default {
  actions
}
